"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SewingPatternSchema = void 0;
const yup = __importStar(require("yup"));
const sewingPatternAttributes_1 = require("../attributes/sewingPatternAttributes");
const shared = __importStar(require("./sharedSchemas"));
const types_1 = require("../types");
const utils_1 = require("./utils");
exports.SewingPatternSchema = yup
    .object({
    productType: shared.productTypeSchema(types_1.ProductTypes['Sewing Patterns']),
    patternType: utils_1.reqSelectOneSchema(Object.values(sewingPatternAttributes_1.PatternType)),
    qualities: yup
        .array(utils_1.reqSelectOneSchema(Object.values(sewingPatternAttributes_1.Qualities)))
        .optional(),
    condition: utils_1.reqSelectOneSchema(Object.values(sewingPatternAttributes_1.Condition)),
    brand: shared.brandSchema.required(),
    patternNumber: yup
        .string()
        .max(10)
        .matches(utils_1.rgx('0-9', false))
        .uppercase()
        .optional(),
    quantity: shared.quantitySchema.optional(),
    price: shared.priceSchema
})
    .test('Context Check', "Product Validator needs product in it's context", (_, context) => {
    var _a;
    if (!((_a = context.options.context) === null || _a === void 0 ? void 0 : _a.product))
        return false;
    return true;
})
    .required();
//# sourceMappingURL=sewingPatternSchema.js.map